import React, { Component } from 'react'
import {DataTable} from 'primereact/datatable';
import {Column} from 'primereact/column'
import {Button} from 'primereact/button';
import { Dropdown } from 'primereact/dropdown';
import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ReactLoading from 'react-loading';
import { CiteService } from '../service/CiteService';
import { SessionService } from '../service/SessionService';
import { AffectationService } from '../service/AffectationService';
import { UtilisateurService } from '../service/UtilisateurService';
import { EcheancierLoyerService } from '../service/EcheancierLoyerService';
import { ParametrePaiementService } from '../service/ParametrePaiementService';
import { messageErreur } from '../service/MessageErreur';


/*
 * Génération de l'échéancier de loyer d'un étudiant affecté à une cité.
 *
 * L'échéancier est désormais créé AUTOMATIQUEMENT à l'affectation du lit.
 * Cet écran sert donc au rattrapage : étudiant affecté avant le paramétrage
 * de la cité, catégorie sans montant au moment de l'affectation, etc.
 */
export class EcheancierLoyer extends Component {

    constructor() {
        super();
        this.state = {
            listeSession : [],
            session : null,
            listeCite : [],
            cite : null,
            parametreCite : null,
            listeAffecte : [],
            listeCategorieChambre : [],
            categoriesChargees : false,

            generationDialog : false,
            affecte : null,
            idCategorieChambre : null,

            echeancier : null,
            echeancierDialog : false,

            loading : false,
            generation : false,
            globalFilter : null
        }

        this.citeService = new CiteService();
        this.sessionService = new SessionService();
        this.affectationService = new AffectationService();
        this.utilisateurService = new UtilisateurService();
        this.echeancierLoyerService = new EcheancierLoyerService();
        this.parametrePaiementService = new ParametrePaiementService();

        this.onCiteChange = this.onCiteChange.bind(this);
        this.onSessionChange = this.onSessionChange.bind(this);
        this.ouvrirGeneration = this.ouvrirGeneration.bind(this);
        this.hideGenerationDialog = this.hideGenerationDialog.bind(this);
        this.genererEcheancier = this.genererEcheancier.bind(this);
        this.actionBodyTemplate = this.actionBodyTemplate.bind(this);
    }

    componentDidMount() {
        const data = localStorage.getItem('user')
        const user = data ? JSON.parse(data) : {}

        const requeteSession = user.idDirection
            ? this.sessionService.getSessionDirection(user.idDirection)
            : this.sessionService.getAll();

        requeteSession.then(data => {
            // pas de libellé de session côté API : on en compose un lisible pour le dropdown
            const sessions = (Array.isArray(data) ? data : []).map(session => ({
                ...session,
                libelleSession : "Session " + session.idAnnee + (session.etatSession ? " - " + session.etatSession : "")
            }));
            // la session la plus récente est celle qu'on veut dans 99% des cas
            const derniere = sessions.length
                ? sessions.reduce((max, item) => item.idAnnee > max.idAnnee ? item : max)
                : null;
            this.setState({listeSession : sessions, session : derniere})
        })
        .catch(error => { console.log(error) })

        this.citeService.getAll().then(data => {
            this.setState({listeCite : Array.isArray(data) ? data : []})
        })
        .catch(error => { console.log(error) })
    }

    onSessionChange(e) {
        this.setState({session : e.value, listeAffecte : []});
        if (this.state.cite) {
            this.chargerAffectes(this.state.cite, e.value);
        }
    }
    onCiteChange(e) {
        const cite = e.value;
        this.setState({cite : cite, listeAffecte : [], parametreCite : null, listeCategorieChambre : [], categoriesChargees : false});

        // sans paramétrage du paiement pour la cité, aucun échéancier ne peut être généré
        this.parametrePaiementService.getParametreCite(cite.idCite).then(data => {
            this.setState({parametreCite : data})
        })
        .catch(error => {
            console.log(error)
            this.setState({parametreCite : null})
        })

        this.citeService.getCategorieChambreCite(cite.idCite, cite.nomCite).then(liste => {
            this.setState({listeCategorieChambre : liste, categoriesChargees : true})
        })
        .catch(error => {
            console.log(error)
            this.notify2("Impossible de charger les catégories de chambre de cette cité.")
            this.setState({listeCategorieChambre : [], categoriesChargees : true})
        })

        this.chargerAffectes(cite, this.state.session);
    }
    chargerAffectes(cite, session) {
        if (!cite || !session) {
            return;
        }
        this.setState({loading : true});
        this.affectationService.getAssignedList(cite.idCite, session.idAnnee).then(data => {
            this.setState({listeAffecte : Array.isArray(data) ? data : [], loading : false})
        })
        .catch(error => {
            console.log(error);
            this.notify2("Impossible de charger la liste des affectés.");
            this.setState({listeAffecte : [], loading : false})
        })
    }

    ouvrirGeneration(rowData) {
        this.setState({
            generationDialog : true,
            affecte : rowData,
            idCategorieChambre : null
        });
    }
    hideGenerationDialog() {
        this.setState({generationDialog : false, affecte : null, idCategorieChambre : null});
    }

    genererEcheancier() {
        const affecte = this.state.affecte;
        if (!this.state.idCategorieChambre) {
            this.notify2("Choisissez une catégorie de chambre.");
            return;
        }
        this.setState({generation : true});

        // l'id étudiant n'est pas toujours porté par la liste des affectés : on le retrouve par l'INE
        const idEtudiant = affecte.idEtudiant
            ? Promise.resolve(affecte.idEtudiant)
            : this.utilisateurService.findByStudent(affecte.ine, this.state.session.idSessionCenou)
                  .then(etudiant => etudiant && etudiant.idEtudiant);

        idEtudiant.then(id => {
            if (!id) {
                throw new Error("idEtudiant introuvable pour l'INE " + affecte.ine);
            }
            return this.echeancierLoyerService.create({
                idEtudiant : id,
                idCite : this.state.cite.idCite,
                idCategorieChambre : this.state.idCategorieChambre,
                idSessionCenou : this.state.session.idSessionCenou
            })
        })
        .then(echeancier => {
            this.notify();
            this.setState({
                echeancier : echeancier,
                echeancierDialog : true,
                generationDialog : false,
                generation : false,
                affecte : null,
                idCategorieChambre : null
            })
        })
        .catch(error => {
            console.log(error);
            this.notify2(messageErreur(error, {
                409 : "Un échéancier est déjà actif pour cet étudiant sur cette année académique.",
                404 : "Étudiant, cité ou catégorie introuvable.",
                400 : "Génération refusée : année académique absente, ou catégorie sans montant défini."
            }));
            this.setState({generation : false});
        })
    }

    libelleTypeEcheance(typeEcheance) {
        if (typeEcheance === "CAUTION") return "Caution";
        if (typeEcheance === "PREMIER_VERSEMENT") return "1er versement";
        if (typeEcheance === "RESTE") return "Reste";
        return typeEcheance;
    }
    formatMontant = (valeur) => Number(valeur).toLocaleString('fr-FR') + " FCFA";

    actionBodyTemplate(rowData) {
        return (
            <Button type="button" label="Générer" icon="pi pi-file" className="p-button-success"
                    disabled={!this.state.parametreCite} onClick={() => this.ouvrirGeneration(rowData)} />
        );
    }

    notify = () => toast.success('Echéancier généré avec succès !', {
            position: "top-right",
            autoClose: 2000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
        });
    notify2 = (message) => toast.error(message || "Echec de l'opération !", {
            position: "top-right",
            autoClose: 10000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
        })
    loadingSpinner = ( type, color) => (
        <ReactLoading type={type} color={color} height={200} width={50} />
    )

    renderEcheancier() {
        const echeancier = this.state.echeancier;
        if (!echeancier) {
            return null;
        }
        const echeances = echeancier.echeances || [];
        const total = echeances.reduce((somme, echeance) => somme + Number(echeance.montant), 0);
        return (
            <div>
                <p style={{marginBottom : "5px"}}>
                    <b>{echeancier.nomEtudiant} {echeancier.prenomEtudiant}</b> ({echeancier.ine}) - {echeancier.nomCite}<br/>
                    Loyer mensuel : <b>{this.formatMontant(echeancier.montantMensuel)}</b>
                    {echeancier.montantTotal !== undefined && <span> &nbsp;|&nbsp; Total : <b>{this.formatMontant(echeancier.montantTotal)}</b></span>}
                </p>
                <table style={{width : "100%", fontSize : "0.9em", borderCollapse : "collapse"}}>
                    <thead>
                        <tr style={{borderBottom : "1px solid #ccc", textAlign : "left"}}>
                            <th>N°</th>
                            <th>Type</th>
                            <th style={{textAlign : "right"}}>Mois</th>
                            <th>Date limite</th>
                            <th style={{textAlign : "right"}}>Montant</th>
                        </tr>
                    </thead>
                    <tbody>
                        {echeances.map(echeance => (
                            <tr key={echeance.idEcheanceLoyer}>
                                <td>{echeance.ordre}</td>
                                <td>{this.libelleTypeEcheance(echeance.typeEcheance)}</td>
                                <td style={{textAlign : "right"}}>{echeance.nombreMois}</td>
                                <td>{echeance.dateLimite ? String(echeance.dateLimite).replace(/-/g, '/') : ''}</td>
                                <td style={{textAlign : "right"}}>{this.formatMontant(echeance.montant)}</td>
                            </tr>
                        ))}
                        <tr style={{borderTop : "1px solid #ccc", fontWeight : "bold"}}>
                            <td colSpan="4">Total</td>
                            <td style={{textAlign : "right"}}>{this.formatMontant(total)}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        );
    }

    render() {
        const header = (
            <div className="table-header p-col-2">
                <span className="p-input-icon-left">
                    <InputText type="search" onInput={(e) => this.setState({ globalFilter: e.target.value })} placeholder="Recherche globale..." />
                </span>
            </div>
        );
        const generationDialogFooter = (
            <React.Fragment>
                <Button label="Quitter" icon="pi pi-times" className="p-button-text" onClick={this.hideGenerationDialog} />
                <Button label="Générer" icon="pi pi-check" className="p-button-text" disabled={this.state.generation} onClick={this.genererEcheancier} />
            </React.Fragment>
        );
        const echeancierDialogFooter = (
            <Button label="Fermer" icon="pi pi-times" className="p-button-text" onClick={() => this.setState({echeancierDialog : false})} />
        );

        return (
            <div className="p-grid">
                <div className="p-col-12">
                    <div className="p-grid">
                        <div className="p-col-4">
                            <Dropdown optionLabel="libelleSession" value={this.state.session} options={this.state.listeSession}
                                      onChange={this.onSessionChange} placeholder="Choisir une session"/>
                        </div>
                        <div className="p-col-4">
                            <Dropdown optionLabel="nomCite" value={this.state.cite} options={this.state.listeCite}
                                      onChange={this.onCiteChange} placeholder="Choisir une cité"/>
                        </div>
                    </div>

                    <div style={{marginBottom : "10px", color : "#555"}}>
                        L'échéancier est créé automatiquement à l'affectation du lit.
                        Cet écran sert à rattraper les étudiants dont l'échéancier n'a pas pu être généré.
                    </div>

                    {this.state.cite && !this.state.parametreCite &&
                        <div style={{color : "red", marginBottom : "10px"}}>
                            Cette cité n'a pas de paramétrage de paiement du loyer.
                            Renseignez-le dans Paramètres &gt; Paiement du loyer avant de générer des échéanciers.
                        </div>
                    }

                    <div className="card card-w-title datatable-demo">
                    <ToastContainer
                        position="top-right"
                        autoClose={2000}
                        hideProgressBar={false}
                        newestOnTop={false}
                        closeOnClick
                        rtl={false}
                        pauseOnFocusLoss
                        draggable
                        pauseOnHover
                    />
                        {header}
                        {this.state.loading ?
                        <div className="p-grid">
                            <div className="p-col-6" ></div>
                            <div className="p-col-6" >
                                {this.loadingSpinner("spin","black")}
                            </div>
                        </div>
                        :
                        <DataTable value={this.state.listeAffecte} selectionMode="single" header="Étudiants affectés" paginator={true} rows={10}
                              globalFilter={this.state.globalFilter} filterMatchMode="contains" responsive={true}>
                            <Column field="ine" header="INE" sortable={true} filter={true} filterPlaceholder="rechercher ine"/>
                            <Column field="nomEtudiant" header="Nom" sortable={true} filter={true} filterPlaceholder="rechercher nom"/>
                            <Column field="prenomEtudiant" header="Prénom" sortable={true} filter={true} filterPlaceholder="rechercher prénom"/>
                            <Column field="nomCite" header="Cité" sortable={true}/>
                            <Column header="Échéancier" body={this.actionBodyTemplate} style={{textAlign:'center', width: '10em'}}/>
                        </DataTable>
                        }
                    </div>
                </div>

                <Dialog visible={this.state.generationDialog} style={{ width: '500px' }} header="Générer l'échéancier" modal className="p-fluid" footer={generationDialogFooter} onHide={this.hideGenerationDialog}>
                    <div className="p-field">
                        <label htmlFor="etudiant">Étudiant</label>
                        <InputText id="etudiant" disabled value={this.state.affecte ? this.state.affecte.nomEtudiant + " " + this.state.affecte.prenomEtudiant + " (" + this.state.affecte.ine + ")" : ''} />
                    </div>
                    <div className="p-field">
                        <label htmlFor="citeGeneration">Cité</label>
                        <InputText id="citeGeneration" disabled value={this.state.cite ? this.state.cite.nomCite : ''} />
                    </div>
                    <div className="p-field">
                        <label htmlFor="categorieChambre">Catégorie de chambre</label>
                        <Dropdown id="categorieChambre" optionLabel="libelleCategorieChambre" optionValue="idCategorieChambre"
                                  value={this.state.idCategorieChambre} options={this.state.listeCategorieChambre}
                                  onChange={(e) => this.setState({idCategorieChambre : e.value})} placeholder="Choisir une catégorie"/>
                        {this.state.categoriesChargees && !this.state.listeCategorieChambre.length ?
                            <small style={{color : "red"}}>Aucune catégorie de chambre n'est rattachée à cette cité.</small>
                            :
                            <small>Le loyer mensuel est le prix de cette catégorie dans la cité.</small>}
                    </div>
                </Dialog>

                <Dialog visible={this.state.echeancierDialog} style={{ width: '550px' }} header="Échéancier généré" modal className="p-fluid" footer={echeancierDialogFooter} onHide={() => this.setState({echeancierDialog : false})}>
                    {this.renderEcheancier()}
                </Dialog>
            </div>
        )
    }
}

export default EcheancierLoyer
